var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6236 6.58136C9.24147 5.46474 6.62958 4.92562 4 5.0078V16.2578C6.62001 16.094 9.23671 16.6262 11.5847 17.8001L12 18.0078L12.4153 17.8001C14.7633 16.6262 17.38 16.094 20 16.2578V5.0078C17.3704 4.92562 14.7585 5.46474 12.3764 6.58136L12 6.7578L11.6236 6.58136Z",
    fill: "#43494F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideIcon);
export default __webpack_public_path__ + "static/media/guide-icon.104ff0ca7b69567eb120b10472c4d713.svg";
export { ForwardRef as ReactComponent };